import Overlay from 'components/Overlay';
import LoadingIndicator from 'components/LoadingIndicator';
import * as React from 'react';

import './styles/OverlayLoading.scss';

/**
 * [Overlay](/internal/components/Overlay) styled to indicate loading.
 *
 * ```example
 * <div style={{ width: 400, position: 'relative' }}>
 *   <OverlayLoading />
 *   <span>
 *     Overlayed content - Perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque,
 *     totam rem  aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae
 *     dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit,
 *     sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam
 *     est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius
 *     modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.
 *   </span>
 * </div>
 * ```
 */

function OverlayLoading() {
  return (
    <Overlay className="OverlayLoading">
      <LoadingIndicator />
    </Overlay>
  );
}

export default OverlayLoading;
